<app-loader *ngIf="showLoading"></app-loader>
<form>
    <div class="main-wrapper">
        <app-header> </app-header>
        <app-leftmenu></app-leftmenu>
        <div class="page-wrapper">
            <div class="content container-fluid">
                <!-- Page Header -->
                <div class="page-header">
                    <div class="row align-items-center">
                        <div class="col">
                            <h3 class="page-title">{{PageTitle}}</h3>
                            <ul class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a routerLink="/Dashboard"> Dashboard</a>
                                </li>
                                <li class="breadcrumb-item active">{{PageTitle}}</li>
                            </ul>
                        </div>
                        <div class="col-auto float-right ml-auto">
                            <!-- <button mat-flat-button color="warn" (click)="filterFunc()">
                                <mat-icon aria-hidden="false">filter</mat-icon> Filter
                            </button> -->
                            <button mat-flat-button color="accent" (click)="addVehicleService()">
                                <mat-icon aria-hidden="false">add</mat-icon> Add Vehicle Service
                            </button>
                        </div>
                    </div>
                </div>
                <!-- /Page Header -->
                <div class="tab-content">
                    <!-- Add Service -->
                    <div class="pro-overview tab-pane fade show active">
                        <div class="card">
                            <!-- Search Table -->
                            <div class="row align-items-center">
                                <div class="col">
                                    <div class="total-rec">Total Records: {{totalRecords}}</div>
                                </div>
                                <div class="col-auto float-right ml-auto">
                                    <mat-form-field class="search-input">
                                        <input matInput (keyup)="applyFilter($event)" placeholder="Search..." #input>
                                    </mat-form-field>
                                </div>
                            </div>
                            <table mat-table [dataSource]="VehicleServiceMasterData" matSort class="mat-elevation-z8">
                                <!--  Name Column -->
                                <ng-container matColumnDef="vehicleRegistrationNumber">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Vehicle Registration Number
                                    </th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData"
                                        data-label="Vehicle Reg. No.">
                                        <div class="block"> {{VehicleServiceMasterData.vehicleRegistrationNumber}}
                                        </div>
                                    </td>
                                </ng-container>
                                <!--  Service Column -->
                                <ng-container matColumnDef="servicePeriodFrom">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Service Period From</th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData" data-label="Service Period From">
                                        <div class="block"> {{VehicleServiceMasterData.servicePeriodFrom |date}} </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="servicePeriodTo">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Service Period To </th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData" data-label="Service Period to">
                                        <div class="block"> {{VehicleServiceMasterData.servicePeriodTo |date}} </div>
                                    </td>
                                </ng-container>
                                <!--  Status Column -->
                                <ng-container matColumnDef="serviceStatus">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Service Status </th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData ">
                                        <div class="block"> {{VehicleServiceMasterData.serviceStatus}} </div>
                                    </td>
                                </ng-container>
                                <!--  Due Date Column -->
                                <ng-container matColumnDef="nextServiceDueDate">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Next Service Due Date </th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData " data-label="Next Service">
                                        <div class="block"> {{VehicleServiceMasterData.nextServiceDueDate | date}}
                                        </div>
                                    </td>
                                </ng-container>
                                <!-- Action Column -->
                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> Action </th>
                                    <td mat-cell *matCellDef="let VehicleServiceMasterData">
                                        <button mat-flat-button color="primary" matTooltip="Edit this record"
                                            [disabled]="VehicleServiceMasterData.isdeleted"
                                            [routerLink]="['/updateVehicleService', VehicleServiceMasterData.vehicleRegistrationNumber,'edit']"
                                            title="Edit">
                                            <mat-icon aria-hidden="false">edit</mat-icon>
                                        </button>
                                        <button mat-flat-button color="warn"
                                            [disabled]="VehicleServiceMasterData.isdeleted"
                                            (click)="deleteVehicleService(VehicleServiceMasterData.vehicleRegistrationNumber)"
                                            matTooltip="Delete this record">
                                            <mat-icon aria-hidden="false">delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <mat-paginator [pageSize]="pageSizedisplay" [pageSizeOptions]="itemPerPage"
                                showFirstLastButtons>
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>